import { Post, PostJson } from "../core/Helper";

export class StudyReportService {
  static async GetList(params) {
    let result = await PostJson("api/report/study-branch-report", params);
    return (await result) ?? null;
  }

  static async GetStudyResults(params) {
    let result = await PostJson(
      "api/studyinfo/getStudyInfoWithHistory",
      params
    );
    return (await result) ?? null;
  }

  static async GetStudyInfo(params) {
    let result = await Post("api/studyinfo/getStudyInfo", params);
    return (await result) ?? null;
  }
}
